'use es6';

import omit from '../utils/underscore/omit';
import UIAbstractPageTemplate from './UIAbstractPageTemplate';
import { jsx as _jsx } from "react/jsx-runtime";
function UIListingPage(props) {
  return /*#__PURE__*/_jsx(UIAbstractPageTemplate, Object.assign({}, props, {
    horizontalDivider: true
  }));
}
UIListingPage.propTypes = omit(UIAbstractPageTemplate.propTypes, 'horizontalDivider', 'sidebarStyle');
/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UIListingPage.defaultProps = omit(UIAbstractPageTemplate.defaultProps, 'horizontalDivider');
UIListingPage.displayName = 'UIListingPage';
export default UIListingPage;